import React from 'react'
import PropTypes from 'prop-types'
import {isToday, format} from 'ag-common/facades'


function DatePickerCell({date, marked, selected, onClick, isActive}) {
  const classes = ['date-picker-cell noselect']
  if (isActive) classes.push('active')
  if (marked) classes.push('marked')
  if (selected) classes.push('selected')
  if (isToday(date)) classes.push('today')
  return (
    <div className={classes.join(' ')} onClick={onClick} role="button" tabIndex={0} onKeyPress={() => {}}>
      <div className="background" />
      <div className="date-picker-cell-content">{format(date, 'd')}</div>
    </div>
  )
}

DatePickerCell.propTypes = {
  date: PropTypes.instanceOf(Date),
  marked: PropTypes.bool,
  selected: PropTypes.bool,
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
}

export default DatePickerCell
